import usePromos from "../../hooks/use-promos";
import Card from "../UI/Card";
import { currencyFormatter } from "../../api/Functions";
import Button from "../UI/Button";
import { useModal } from "../../hooks/use-modal.jsx";
import PromosForm from "./PromosForm";
import { useState } from "react";

export default function Promos() {
  const { promos, createPromo } = usePromos();
  const [PromoModal, closePromoModal, openPromoModal] = useModal();
  const [promoToEdit, setPromoToEdit] = useState(null);

  return (
    <>
      <PromoModal size={"medium"}>
        <PromosForm
          onSubmit={async (promo) => {
            await createPromo(promo);
            closePromoModal();
            setPromoToEdit(null);
          }}
          promo={promoToEdit}
        />
      </PromoModal>
      {promos.map((promo, i) => (
        <Card className={"marginB10"} padding={"sm"} key={i}>
          <div className={"flex space-between"}>
            <p className={"primaryText marginB10"}>{promo.code}</p>
            <div>
              <Button
                onClick={() => {
                  setPromoToEdit(promo);
                  openPromoModal();
                }}
              >
                Dupliquer
              </Button>
            </div>
          </div>
          <p>
            <strong>Compte</strong> : {promo.id_compte}
          </p>
          <p>
            <strong>Type</strong> : {promo.remuneration_type["type"]}{" "}
            <strong>Montant</strong> :{" "}
            {promo.remuneration_type["type"] === "forfait"
              ? currencyFormatter(promo.remuneration_type["montant"] / 100)
              : promo.remuneration_type["montant"] + "%"}
          </p>
          <p>
            <strong>Montant à payer</strong> :{" "}
            {currencyFormatter(promo.montant_a_payer / 100)}
          </p>
          <p>
            <strong>Montant total</strong> :{" "}
            {currencyFormatter(promo.montant_total / 100)}
          </p>
          <p>
            <strong>Benefit</strong> : {promo.benefit["days"]} jours
          </p>
        </Card>
      ))}
    </>
  );
}
